import HttpClient from './HttpClient';
import { OPINION_SERVICE_HOST, OPINIONS_API_PREFIX } from './RestConstants';

export interface SignupData {
  username: string;
  email: string;
  password: string;
}

export interface LoginData {
  email: string;
  password: string;
}

export interface AuthResponse {
  success: boolean;
  message: string;
  data: {
    user: {
      _id: string;
      username: string;
      email: string;
      profilePicture?: string;
    };
  };
}

class AuthService {
  private static readonly BASE_URL = OPINION_SERVICE_HOST;
  private static readonly AUTH_PREFIX = `${OPINIONS_API_PREFIX}/auth`;

  static async signup(data: SignupData): Promise<AuthResponse> {
    const url = `${this.BASE_URL}${this.AUTH_PREFIX}/signup`;
    console.log('Signup API call:', url, data);
    const response = await HttpClient.POST({
      BASE_URL: this.BASE_URL,
      END_POINT: `${this.AUTH_PREFIX}/signup`,
      data
    });
    console.log('Signup response:', response.data);
    return response.data;
  }

  static async login(data: LoginData): Promise<AuthResponse> {
    const url = `${this.BASE_URL}${this.AUTH_PREFIX}/login`;
    console.log('Login API call:', url, data);
    const response = await HttpClient.POST({
      BASE_URL: this.BASE_URL,
      END_POINT: `${this.AUTH_PREFIX}/login`,
      data
    });
    console.log('Login response:', response.data);
    return response.data;
  }

  static async verifyToken(): Promise<any> {
    const response = await HttpClient.GET({
      BASE_URL: this.BASE_URL,
      END_POINT: `${this.AUTH_PREFIX}/verify`
    });
    return response.data;
  }

  static getGoogleAuthUrl(): string {
    return `${this.BASE_URL}${this.AUTH_PREFIX}/google`;
  }

  static saveUser(user: any): void {
    localStorage.setItem('user', JSON.stringify(user));
  }

  static getUser(): any {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  }

  static removeUser(): void {
    localStorage.removeItem('user');
  }

  static async logout(): Promise<void> {
    try {
      await HttpClient.POST({
        BASE_URL: this.BASE_URL,
        END_POINT: `${this.AUTH_PREFIX}/logout`,
        data: {}
      });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      this.removeUser();
    }
  }
}

export default AuthService;
